import { AxiosResponse } from "axios";
import { IShopGetCertificateRequest, IShopGetCertificateResponse } from "interfaces";

import { axiosExchange } from "services/axios";

export enum CERTIFICATE_ENDPOINTS {
  getCertificate = "GetCertificate",
}

const SHOP_PREFIX = process.env.REACT_APP_SHOP_PREFIX || "";

const getCertificate = async ({ Ссылка, ПИН }: IShopGetCertificateRequest) => {
  return axiosExchange.post<any, AxiosResponse<IShopGetCertificateResponse>>(
    `${SHOP_PREFIX}/${CERTIFICATE_ENDPOINTS.getCertificate}/1/1/1?noauth`,
    { Ссылка, ПИН }
  );
};

const certificateService = {
  getCertificate,
};

export default certificateService;
